import { Section } from './Section'
import { SectionFullWidth } from './SectionFullWidth'
import { SectionHeader } from './SectionHeader'

export const Structure = {
    Section: Section,
    SectionFullWidth: SectionFullWidth,
    SectionHeader: SectionHeader,
}
